import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AttributeValue,
  EditedAttributeValues,
  FormTypes,
  SectionInstance,
} from '../../../../models/section-definition.model';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lib-section-instance-card',
  standalone: false,
  templateUrl: './section-instance-card.component.html',
  styleUrls: ['./section-instance-card.component.scss'],
  animations: [
    trigger('slideToggle', [
      transition(':enter', [
        style({ height: '0', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class SectionInstanceCardComponent {
  @Input() section!: SectionInstance;
  @Input() editEnabled: boolean = false;
  @Input() editableAttributeIds: number[] = [];
  @Input() editedValues: EditedAttributeValues = {};
  @Output() mapClicked = new EventEmitter<AttributeValue>();
  FormTypes = FormTypes;
  onMapClick(attributeValue: AttributeValue) {
    this.mapClicked.emit(attributeValue);
  }


  getAttributeTypeString(type: number): string {
    return FormTypes[type];
  }

  getRowType(
    attr: AttributeValue,
  ):
    | 'number-edit'
    | 'text-edit'
    | 'date-edit'
    | 'image-edit'
    | 'dropdown-edit'
    | 'selected-options'
    | 'location'
    | 'image'
    | 'file'
    | 'default' {
    if (this.editEnabled && this.editableAttributeIds.includes(attr.attributeDefinitionId)) {
      if (attr.type === this.getAttributeTypeString(FormTypes.Number)) return 'number-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.Text)) return 'text-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.DateTime)) return 'date-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.Image)) return 'image-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.Dropdown)) return 'dropdown-edit';
    }
    if (
      attr.type === this.getAttributeTypeString(FormTypes.MultiSelect) ||
      attr.type === this.getAttributeTypeString(FormTypes.SingleSelect) ||
      attr.type === this.getAttributeTypeString(FormTypes.Dropdown) ||
      attr.type ===
        this.getAttributeTypeString(FormTypes.ConditionalDropdown) ||
      attr.type === this.getAttributeTypeString(FormTypes.ChildDropdown)
    )
      return 'selected-options';
    if (attr.type === this.getAttributeTypeString(FormTypes.Location))
      return 'location';
    if (attr.type === this.getAttributeTypeString(FormTypes.Image))
      return 'image';
    if (attr.type === this.getAttributeTypeString(FormTypes.File))
      return 'file';

    return 'default';
  }
}
